export const Plain_Text = `
<h3>Plain Text</h3>
<hr />
<article id="plain-text">
   <div class="row">
      <div class="col-xl-3 col-lg-3 d-none d-lg-block"></div>
      <div class="col-xl-7 col-lg-7 col-md-12 col-sm-12 d-flex justify-content-xl-center justify-content-lg-center justify-content-md-start justify-content-sm-start">
         <div class="intro">
            Did that imagined scenario give you an uncomfortable feeling? Everyone’s confidence is affected by different things. People of all types can feel less confident in situations that are new or that they perceive to be challenging. But, what boosts confidence in one person may negatively impact the confidence  of someone with a different personality type.
         </div>
      </div>
      <div class="col-xl-2 col-lg-2 d-none d-lg-block"></div>
   </div>
</article>
`;
